import { localisedValue } from "utils"

let commonTransformFunction = data => {
  return data?.map(item => ({
    ...item,
    title: localisedValue({ object: item, key: "projectName" }),
    price: item?.potentialRevenue,
    apartment: localisedValue({ object: item, key: "listingUnitNumber" }),
    leadId: item?.inquiryId,
    leadName: localisedValue({ object: item, key: "clientName" }),
    agentImage: item?.userProfilePicture,
    calls: item?.numberOfPhoneCalls,
    meeting: item?.numberOfMeetingsDone,
    date: item?.date,
    percentage: item?.conversionProbability,
    aiPercentage: item?.aiClosureProbability,
    totalPotentialRevenue: item?.totalRevenue || 0,
    totalReportedRevenue: item?.totalReportedRevenue || 0,
    totalRecognizedRevenue: item?.totalRecognizedRevenue || 0,
  }))
}
export const salesPipelineDataTransformer = (response, args) => {
  const getStageData = stage => {
    return {
      ...response?.[stage],
      data: commonTransformFunction(response?.[stage].data) || [],
      loadMore: response?.[stage]?.count > args?.pageLimit * (args?.pageIndex + 1),
      totalPotentialRevenue: response?.[stage]?.totalPotentialRevenue || 0,
      totalReportedRevenue: response?.[stage]?.totalReportedRevenue || 0,
      totalRecognizedRevenue: response?.[stage]?.totalRecognizedRevenue || 0,
    }
  }
  let actualTransformedData = {
    prospect: getStageData("prospect"),
    matured: getStageData("matured"),
    preclosure: getStageData("preclosure"),
    partialSold: getStageData("partialSold"),
    sold: getStageData("sold"),
    max: Math.max(
      response?.preclosure?.count,
      response?.matured?.count,
      response?.sold?.count,
      response?.prospect?.count,
      response?.partialSold?.count
    ),
  }

  return { [args.pageIndex]: actualTransformedData }
}
